// Auth Store

const state = {
  errors: [],
  location: null,
  message: null,
  pending: false,
  pendingRoutes: false,
  pendingSettings: false,
  routes: [],
  status: false,
  user: null,
  selected_language: null,
  settings: {},
  settingsRoutes: [],
  signup_config: null,
  allow_posts_without_grp_and_topic: false,
  auth_redirect: null,
}

const getters = {}

const actions = {
  login({ commit, dispatch }, { username, password }) {
    const loginData = { email: username, username: username, password: password }
    if (state.settings.login_options && state.settings.login_options.login_identifier === 'username') {
      delete loginData.email
    } else {
      delete loginData.username
    }
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.http
        .post('auth/login', loginData)
        .then(async ({ data }) => {
          if (data.errors) {
            commit('LOGIN_FAIL', data)
            resolve()
            return
          }

          if (!data.agb_nda_accepted) {
            commit('LOGIN_AGB_NDA_REQUIRED', data)
            resolve(data)
            return
          }

          this.pushService.unsubscribe()
          commit('LOGIN_SUCCESS', data)
          dispatch('getRoutes')
          this.pushService.subscribe()

          const chat = await this.dispatch('chat/chat')
          chat.createSubscription()

          const notification = await this.dispatch('activities/notification')
          notification.createSubscription()

          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING')
        })
    })
  },
  getRoutes({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING_ROUTES')
      this.api.items.getItems('menu').then(({ data }) => {
        commit('SET_ROUTES', data)
        commit('SET_PENDING_ROUTES')
        resolve()
      })
    })
  },
  getSettings({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING_SETTINGS', { pending: false })
      if (window.settings) {
        commit('SET_SETTINGS', window.settings)
        commit('SET_PENDING_SETTINGS', { pending: false })
        resolve()
      } else {
        this.api.items.getItems('settings').then(({ data }) => {
          commit('SET_SETTINGS', data)
          window.settings = data
          commit('SET_PENDING_SETTINGS', { pending: false })
          resolve()
        })
      }
    })
  },
  getSettingsMenu({ commit, dispatch }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItems('menu.settings').then(({ data }) => {
        commit('SET_MENU_SETTINGS', data)
        resolve()
      }).finally(_ => {
        dispatch('getRoutes')
        commit('SET_PENDING')
      })
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.auth
      .logout()
      .then(async _ => {
        const chat = await this.dispatch('chat/chat')
        chat.removeSubscription()

        const notification = await this.dispatch('activities/notification')
        notification.removeSubscription()

        commit('LOGOUT_SUCCESS')
        resolve()
      })
      .catch(error => {
        reject(error)
      })
      .finally(_ => {
        commit('SET_PENDING')
      })
    })
  },
  initAuth({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.auth.isAuthenticated()
        .then(async ({ data }) => {
          if (!data.isAuthenticated) {
            if (data.redirect) {
              commit('LOGIN_REDIRECT', data)
            }
            resolve()
            return
          }
          this.pushService.unsubscribe()
          commit('LOGIN_SUCCESS', data)
          this.pushService.subscribe()

          const chat = await this.dispatch('chat/chat')
          chat.createSubscription()

          const notification = await this.dispatch('activities/notification')
          notification.createSubscription()

          resolve()
        }).catch(error => {
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING')
        })
    })
  },
  forgotPassword({ commit }, { email }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.auth
        .postForgotPassword(email)
        .then(({ data }) => {
          if (data.errors) {
            commit('FORGOT_PASSWORD_FAIL', data)
            resolve()
            return
          }

          commit('FORGOT_PASSWORD_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING')
        })
    })
  },
  acceptNdaAgb({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.items.editItem('auth.accept_nda_agb', { user_id: state.user.user_id })
        .then(_ => {
          commit('ACCEPT_NDA_AGB_SUCCESS')
          dispatch('initAuth')
          resolve()
        })
        .catch(error => {
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING')
        })
    })
  },
  resetPassword({ commit }, { user_id, hash, new_password, new_password_confirm }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.http
        .post('auth/reset_password', { user_id, hash, new_password, new_password_confirm })
        .then(({ data }) => {
          if (data.errors) {
            commit('RESET_PASSWORD_FAIL', data)
            resolve()
            return
          }

          commit('RESET_PASSWORD_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING')
        })
    })
  },
  changePassword({ commit }, { current_password, new_password, new_password_confirm }) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING')
      this.api.items
        .createItem('auth/reset_password', { current_password, new_password, new_password_confirm })
        .then(({ data }) => {
          if (data.errors) {
            commit('RESET_PASSWORD_FAIL', data)
            resolve()
            return
          }

          commit('RESET_PASSWORD_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING')
        })
    })
  },
  updateImgPath({ commit }, img_path) {
    commit('UPDATE_IMAGE_PATH', img_path)
  },
  clearAuthError({ commit }) {
    commit('CLEAR_AUTH_ERROR')
  },
  clearMessage({ commit }) {
    commit('CLEAR_MESSAGE')
  },
  setFieldErrors({ commit }, errors) {
    commit('SET_FIELD_ERRORS', errors)
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_PENDING_ROUTES: state => {
    state.pendingRoutes = !state.pendingRoutes
  },
  SET_PENDING_SETTINGS: (state, { pending }) => {
    state.pendingSettings = pending || !state.pendingSettings
  },
  LOGIN_SUCCESS(state, { status, user, selected_language, location, allow_posts_without_grp_and_topic }) {
    state.status = status
    state.user = user
    state.selected_language = selected_language
    state.location = location
    state.allow_posts_without_grp_and_topic = allow_posts_without_grp_and_topic
    state.errors = []
  },
  LOGIN_REDIRECT(state, { redirect }) {
    state.auth_redirect = redirect
  },
  LOGIN_AGB_NDA_REQUIRED(state, { user, selected_language }) {
    state.selected_language = selected_language
    state.user = user
    state.errors = []
  },
  LOGIN_FAIL(state, { errors }) {
    state.selected_language = null
    state.errors = errors
  },
  ACCEPT_NDA_AGB_SUCCESS(state) {
    state.user.agb_nda_accepted = true
  },
  LOGOUT_SUCCESS(state) {
    state.selected_language = null
    state.status = false
    state.user = null
    state.location = null
    state.allow_posts_without_grp_and_topic = false
    state.errors = []
  },
  FORGOT_PASSWORD_SUCCESS(state, { message }) {
    state.errors = []
    state.message = message
  },
  FORGOT_PASSWORD_FAIL(state, { errors }) {
    state.errors = errors
  },
  RESET_PASSWORD_SUCCESS(state, { message }) {
    state.erros = []
    state.message = message
  },
  RESET_PASSWORD_FAIL(state, { errors }) {
    state.errors = errors
  },
  SET_ROUTES(state, routes) {
    state.routes = routes
  },
  SET_SETTINGS(state, settings) {
    state.settings = settings
    const conf = settings.signup_configuration
    state.signup_config = !conf || !conf.active ?
    null :
    {
      active: true,
      type: conf.type === 'basic' ? 'default' : 'variant',
      social: conf.type === 'advanced' && conf.active_login_types,
    }
  },
  SET_MENU_SETTINGS(state, settingsRoutes) {
    state.settingsRoutes = settingsRoutes
  },
  UPDATE_IMAGE_PATH(state, img_path) {
    state.user.img_path = img_path
  },
  CLEAR_AUTH_ERROR: state => {
    state.errors = []
  },
  CLEAR_MESSAGE: state => {
    state.message = null
  },
  SET_FIELD_ERRORS(state, errors) {
    state.errors = errors
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
